import { render, staticRenderFns } from "./EwfPromo.vue?vue&type=template&id=95b74d6a&scoped=true&"
import script from "./EwfPromo.vue?vue&type=script&lang=js&"
export * from "./EwfPromo.vue?vue&type=script&lang=js&"
import style0 from "./EwfPromo.vue?vue&type=style&index=0&id=95b74d6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b74d6a",
  null
  
)

export default component.exports